import Axios from "axios";
import {
  antdMessageError,
  antdMessageSuccess,
  errorHandler,
} from "../../helpers/Utils";

export const postMassSupplyings = (variables, extras) => (dispatch) => {
  return Axios.post("/api/v1/supplyings/set_mass_supplyings", variables)
    .then((res) => {
      dispatch({
        type: "UPDATE_BULK_SUPPLYINGS",
        payload: { ...extras, supplyings: res.data.supplyings },
      });
      antdMessageSuccess();
      return { success: true };
    })
    .catch((err) => {
      errorHandler(err);
      antdMessageError();
      return { success: false };
    });
};
